"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const gtm_1 = require("./config/gtm");
const enums_1 = require("./enums");
const services_1 = require("./services");
const ga4_service_1 = __importDefault(require("./services/ga4.service"));
const themis_analytics_options_validator_1 = __importDefault(require("./services/validators/themis-analytics-options.validator"));
class ThemisAnalytics {
    constructor(options) {
        var _a;
        this.defaultOptions = Object.assign({}, (0, gtm_1.getAnalyticsOptionsDefaults)((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname), options);
        this.gtmService = new services_1.GTMService(this.defaultOptions);
        this.ga4Service = new ga4_service_1.default(this.gtmService);
        this.analyticsOptionsValidator = new themis_analytics_options_validator_1.default();
    }
    initialize(analyticsOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = Object.assign({}, this.defaultOptions, analyticsOptions);
            let initialized = false;
            this.analyticsOptionsValidator.validate(options);
            // The SWITCHes on client is an architectural reminder
            // This is patterned to support many different analytics clients
            // mostly this is here to support a move to if needed
            switch (options.client) {
                case enums_1.AnalyticServiceVendor.GoogleTagManager:
                    initialized = yield this.gtmService.initialize(options);
                    break;
            }
            return initialized;
        });
    }
    triggerAddPaymentInfoEvent(data) {
        return this.ga4Service.triggerAddPaymentInfoEvent(data);
    }
    triggerAddShippingInfoEvent(data) {
        return this.ga4Service.triggerAddShippingInfoEvent(data);
    }
    triggerAddToCartEvent(data) {
        return this.ga4Service.triggerAddToCartEvent(data);
    }
    triggerBeginCheckoutEvent(data) {
        return this.ga4Service.triggerBeginCheckoutEvent(data);
    }
    triggerCustomEvent(name, variables) {
        var _a;
        switch ((_a = this.defaultOptions) === null || _a === void 0 ? void 0 : _a.client) {
            case enums_1.AnalyticServiceVendor.GoogleTagManager:
                this.gtmService.triggerCustomEvent(name, variables);
                break;
        }
    }
    triggerEvent(name) {
        var _a;
        switch ((_a = this.defaultOptions) === null || _a === void 0 ? void 0 : _a.client) {
            case enums_1.AnalyticServiceVendor.GoogleTagManager:
                this.gtmService.triggerEvent(name);
                break;
        }
    }
    triggerGenericEvent(event, timeout) {
        var _a;
        return ((_a = this === null || this === void 0 ? void 0 : this.defaultOptions) === null || _a === void 0 ? void 0 : _a.client)
            ? this.gtmService.triggerGenericEvent(event, timeout)
            : new Promise((resolve) => resolve('warning: no tracking client set'));
    }
    triggerLoginEvent(event) {
        return this.ga4Service.triggerLoginEvent(Object.assign(Object.assign({}, event), { event: 'login' }));
    }
    triggerPurchaseEvent(data) {
        return this.ga4Service.triggerPurchaseEvent(data);
    }
    triggerRemoveFromCartEvent(data) {
        return this.ga4Service.triggerRemoveFromCartEvent(data);
    }
    triggerSelectItemEvent(data) {
        return this.ga4Service.triggerSelectItemEvent(data);
    }
    triggerSelectPromotionEvent(data) {
        return this.ga4Service.triggerSelectPromotionEvent(data);
    }
    triggerSignUpEvent(event) {
        return this.ga4Service.triggerSignUpEvent(event);
    }
    triggerTutorialBeginEvent() {
        return this.ga4Service.triggerTutorialBeginEvent();
    }
    triggerTutorialCompleteEvent() {
        return this.ga4Service.triggerTutorialCompleteEvent();
    }
    triggerViewCartEvent(data) {
        return this.ga4Service.triggerViewCartEvent(data);
    }
    triggerViewItemEvent(data) {
        return this.ga4Service.triggerViewItemEvent(data);
    }
    triggerViewItemListEvent(data) {
        return this.ga4Service.triggerViewItemListEvent(data);
    }
    triggerViewPromotionEvent(data) {
        return this.ga4Service.triggerViewPromotionEvent(data);
    }
}
exports.default = ThemisAnalytics;
//# sourceMappingURL=themis-analytics.js.map